export default {
    namespaced: true,

    state() {
        return {
            mobilePhone: null,
            ssnLast4: null,
            prefilledFields: [],
        }
    },

    mutations: {
        updateMobilePhone(state, mobilePhone) {
            state.mobilePhone = mobilePhone
        },

        updateSsnLast4(state, ssnLast4) {
            state.ssnLast4 = ssnLast4
        },

        updatePrefilledFields(state, prefilledFields) {
            state.prefilledFields = prefilledFields
        },
    },
}
